import MaskToggle from './MaskToggle';

// after |GG| / |GK|: private section unknown (free placement) or measured (dashed)
export function BoundaryPrompt({ t, bnd, onUnknown, onMeasured, onClose }) {
  if (!bnd) return null;
  return (
    <div className="bnd-bar mask" data-testid="boundary-prompt">
      <MaskToggle t={t} id="boundary" />
      <b className="mask-keep">{bnd.kind === 'gg' ? '🚧 |GG|' : '🧱 |GK|'} {t.bndAsk}</b>
      <button className="btn btn-outline btn-sm" data-testid="boundary-unknown-btn" onClick={onUnknown}>📍 {t.bndOptA}</button>
      <button className="btn btn-accent btn-sm" data-testid="boundary-measured-btn" onClick={onMeasured}>📏 {t.bndOptB}</button>
      <button className="btn btn-outline btn-sm" data-testid="boundary-close-btn" onClick={onClose}>{t.glCancel}</button>
    </div>
  );
}

export function PrivModeBar({ t, on, onEnd }) {
  if (!on) return null;
  return (
    <div className="bnd-bar priv-mode mask" data-testid="priv-mode-bar">
      <b className="mask-keep">⚠️ {t.privModeOn}</b>
      <button className="btn btn-outline btn-sm" data-testid="priv-mode-end-btn" onClick={onEnd}>{t.privModeEnd}</button>
    </div>
  );
}
